import React, { Component } from "react"
import ButtonsForm from "../../../components/ButtonsForm"
import { Link, Redirect } from 'react-router-dom'
import auth from "../../../utils/auth"
import cfg from "../../../utils/config"
import axios from "axios"
import helper from "../../../utils/helper"
import Mapa from "../../../components/Mapa"
import { divIcon } from 'leaflet'
import ReactDOMServer from 'react-dom/server'

class Form extends Component {
    userInfo = auth.getUserInfo()
    mapRef = null

    state = {
        detalhes: { name: null, description: null, gateway_id: null, stats_interval: 30 },
        cooldown: false,
        redirect: false,
        path: "",
        position: [0, 0],
        altitude: 0,
        markers: [],
        dashboard: false
    }

    get gatewayId() {
        if (this.props.isQuickRegister && this.props.gatewayId) {
            return this.props.gatewayId;
        }

        return this.props?.match?.params?.id;
    }

    componentDidMount = () => {
        const url = window.location.search
        const urlSearchParams = new URLSearchParams(url)
        const dashboard = urlSearchParams.get('dashboard')
        if (dashboard) {
            this.setState({ dashboard: true })
        }

        if (this.gatewayId) {
            this.getData()
        } else {
            setTimeout(() => {
                if (this.mapRef != null) {
                    this.mapRef.current.setView([-17.408282, -53.117169], 4)

                    let markers = [{
                        latitude: -17.408282,
                        longitude: -53.117169,
                        draggable: true,
                        iconElement: this.createDivIcon({ cor: "#0062b1", icone: "las la-cloud", nome: "" })
                    }]

                    this.setState({ markers })
                }
            }, 500)
        }
    }

    getData = () => {
        const requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/gateway/' + this.gatewayId + '/'
        let config_me = { headers: { 'Authorization': 'Bearer ' + auth.getToken() } }

        axios.get(requestURL, config_me).then(({ data }) => {
            const detalhes = { name: data.name, description: data.description, gateway_id: data.gateway_id, stats_interval: data.stats_interval }
            const latitude = data.location?.latitude ?? -17.408282
            const longitude = data.location?.longitude ?? -53.117169
            const altitude = data.location?.altitude ?? 0

            let markers = []
            let position = [latitude, longitude]

            if (this.mapRef != null) {
                this.mapRef.current.setView(position, 4)

                markers = [{
                    latitude: latitude,
                    longitude: longitude,
                    draggable: true,
                    iconElement: this.createDivIcon({ cor: "#0062b1", icone: "las la-cloud", nome: "" }),
                }]
            }

            this.setState({ detalhes, position, markers, altitude })
        })
    }

    handleChange = (field, value, isNumber = false) => {
        const detalhes = Object.assign({}, this.state.detalhes)
        const span = document.getElementById(`validacao-${field}`)

        if (isNumber) {
            value = value.replace(/[.,e]/g, "")
            value = value ? parseInt(value) : 0
        }

        detalhes[field] = value

        if (span) {
            span.innerHTML = ""
        }

        this.setState({ detalhes })
    }

    handleQuickRegister = async () => {
        return new Promise((resolve) => {
            const { description, ...camposObrigatorios } = this.state.detalhes;

            const todosPreenchidos = Object.values(camposObrigatorios).every(
                (value) =>
                    value !== null &&
                    value !== undefined &&
                    !(typeof value === "string" && value.trim() === "")
            );

            if (!todosPreenchidos) {
                helper.dispatchEvent("showAviso", {
                    message: `Os campos obrigatórios do gateway não foram preenchidos. Deseja prosseguir sem adicionar um gateway?`,
                    callback: () => {
                        resolve({
                            success: true
                        });
                        return
                    },
                    callbackClose: () => {
                        resolve({ success: false })
                    },
                    callbackLabelClose: "Não"
                });
                return
            }

            this.saveAction(false, resolve);
        });
    };

    saveAction = (novoCadastro, resolve = null) => {
        const { detalhes } = this.state

        this.setState({ cooldown: true })

        let requestURL = ""
        let verb = ""
        const gatewayId = this.gatewayId

        if (gatewayId) {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/gateway/' + gatewayId + '/'
            verb = 'patch'
        } else {
            requestURL = cfg.base_api_url + cfg.api_v2 + '/' + this.userInfo.empresa + '/lns/gateway/'
            verb = 'post'
        }

        let data = {
            name: detalhes.name,
            description: detalhes.description,
            gateway_id: detalhes.gateway_id,
            stats_interval: detalhes.stats_interval,
            location: {
                latitude: this.state.position[0],
                longitude: this.state.position[1],
                altitude: this.state.altitude
            }
        }

        axios({
            method: verb,
            url: requestURL,
            data: data,
            headers: { 'Content-Type': 'application/json', 'Authorization': 'Bearer ' + auth.getToken() }
        }).then((res) => {
            if (novoCadastro) {
                window.location.reload()
            } else {
                helper.dispatchEvent("showAviso", {
                    message: `Gateway ${verb === "post" ? "criado" : "editado"} com sucesso.`,
                    callback: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    gatewayId: res.data.id,
                                })
                            };
                            return
                        };

                        this.setState({
                            redirect: true,
                            path: this.state.dashboard ? "/lns/dashboard" : "/lns/gateway"
                        })
                    },
                    callbackClose: () => {
                        if (this.props.isQuickRegister) {
                            if (resolve) {
                                resolve({
                                    success: true,
                                    gatewayId: res.data.id,
                                })
                            };
                            return
                        };
                        if (verb === "post") {
                            window.location.href = `/lns/gateway/${res.data.id}/editar`;
                            setTimeout(() => { window.location.reload(); }, 1000);
                        }
                    }
                });
            }
        }).catch((error) => {
            if (resolve) resolve({
                success: false,
            });

            if (typeof error.response.data === "string") {
                helper.dispatchEvent("showAviso", {
                    message: error.response.data
                });

                return;
            }

            let erros = Object.entries(error.response.data)

            if (Array.isArray(erros)) {
                for (let i = 0; i < erros.length; i++) {
                    let span = document.querySelector(`#validacao-${erros[i][0]}`)
                    if (span) span.innerHTML = erros[i][1]
                }
            }
        })

        setTimeout(() => this.setState({ cooldown: false }), 1000)
    }

    handleTab = (index) => this.setState({ tab: index })

    createDivIcon = (data) => {
        return divIcon({
            className: 'default-div-icon',
            iconSize: [32, 64],
            iconAnchor: [16, 64],
            popupAnchor: [0, -64],
            html: ReactDOMServer.renderToString(
                <div className="default-marker-container" style={{ backgroundColor: data.cor }} title={data?.nome}>
                    <i className={data.icone + " la-2x"}></i>
                    <div className="default-marker-gradient"></div>
                    <div style={{ backgroundColor: data.cor }} className="default-marker-triangle"></div>
                </div>
            ),
        })
    }

    setAddress = (position) => {
        let lat = position[0].toFixed(6)
        let lng = position[1].toFixed(6)

        this.setState({ position: [Number(lat) , Number(lng)] })
    }

    handleAltitudeChange = (value) => {
        const altitude = parseFloat(value) || 0
        this.setState({ altitude })
    }

    render() {
        const { detalhes } = this.state

        if (this.state.redirect) {
            return <Redirect to={this.state.path} />
        }

        return (
            <div>
                <div className="hdv-default-header mx-3">
                    <span className="screen-menu-desc">
                        <i
                            className="fa fa-info-circle fa-20px"
                            title='Informações do Cadastro de Gateway'
                            style={{ cursor: "pointer", marginTop: '8px', marginRight: '5px' }}
                            onClick={() =>
                                helper.dispatchEvent("showAviso", {
                                    message: `Ao cadastrar um gateway, garanta que ele esteja configurado com o endereço do nosso LNS: <br />
                                        <strong> https://lns.afira.io:1700/ </strong> <br />
                                        <br />
                                        Com isso, todos os dispositivos no alcance desse gateway e cadastrados na plataforma serão automaticamente integrados a ele.`,
                                })
                            }
                        />
                        {(this.props?.match?.params?.id || (this.props.isQuickRegister && this.props.gatewayId))  ? <h4>Editar Gateway</h4> : <h4>Novo Gateway</h4>}
                        <div className="gray-background">
                            <i className="fa fa-wifi fa-2x"></i>
                        </div>
                    </span>
                </div>

                <div className="hdv-form-default">
                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="name">Nome</label>
                            <input
                                type='text'
                                value={detalhes.name ?? ""}
                                id="name"
                                onChange={(e) => this.handleChange("name", e.target.value)}
                            />
                            <span id='validacao-name'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="description">Descrição</label>
                            <input
                                type='text'
                                value={detalhes.description ?? ""}
                                id="description"
                                onChange={(e) => this.handleChange("description", e.target.value)}
                            />
                            <span id='validacao-description'></span>
                        </div>
                    </div>

                    <div className="row">
                        <div className="col-md-6">
                            <label className='required' htmlFor="gateway_id">ID do gateway (EUI64)</label>
                            <input
                                type='text'
                                value={detalhes.gateway_id ?? ""}
                                id="gateway_id"
                                onChange={(e) => this.handleChange("gateway_id", e.target.value)}
                                disabled={this.gatewayId}
                            />
                            <span id='validacao-gateway_id'></span>
                        </div>
                        <div className="col-md-6">
                            <label className='required' htmlFor="stats_interval">Intervalo de estatísticas (segundos)</label>
                            <input
                                type='text'
                                value={detalhes.stats_interval ?? ""}
                                id="stats_interval"
                                onChange={(e) => this.handleChange("stats_interval", e.target.value, true)}
                            />
                            <span id='validacao-description'></span>
                        </div>
                    </div>

                    <div className="hdv-mapform">
                        <Mapa
                            draggable
                            position={this.state.position}
                            markers={this.state.markers}
                            layerControl={false}
                            onClick={this.setAddress}
                            zoom={4}
                            style={{ height: "400px", top: "0" }}
                            onLoad={(ref) => { this.mapRef = ref }}
                        />
                    </div>
                </div>

                {!this.props.isQuickRegister &&
                    <div className="hdv-btn-group">
                        <ButtonsForm
                            route="/lns/gateway"
                            edit={this.props?.match?.params?.id ? true : false}
                            cooldown={this.state.cooldown}
                            buttons={[
                                {
                                    method: "post",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                },

                                {
                                    method: "post",
                                    button: <button style={{ display: this.props?.match?.params?.id ? "none" : "inline-block" }} onClick={() => this.saveAction(true)} className="hdv-btn-forms hdv-btn-greenlight">Salvar e Cadastrar um Novo</button>
                                },

                                {
                                    method: "patch",
                                    button: <button onClick={() => this.saveAction(false)} className="hdv-btn-forms hdv-btn-green">Salvar</button>
                                },
                            ]}
                        />

                        <Link to={this.state.dashboard ? "/lns/dashboard" : "/lns/gateway"}>
                            <button className="hdv-btn-forms hdv-btn-orange">Cancelar</button>
                        </Link>
                    </div>
                }
            </div>
        )
    }
}

export default Form